import type { NavItem, SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Serene Corpse',
    description: 'Official website of Serene Corpse, an independent artist creating music, lyrics, poetry and cinematic stories. Where emotions find their melody.',
    tagline: 'Where emotions find their melody.',
    statement: 'No fixed genre. No single emotion. No ordinary stories.'
}

export const mainNav: Array<NavItem> = [
    { href: '/', label: 'Home' },
    { href: '/music', label: 'Music' },
    { href: '/albums', label: 'Albums & EPs' },
    { href: '/lyrics', label: 'Lyrics' },
    { href: '/videos', label: 'Videos' },
    { href: '/journal', label: 'Poetry & Journal' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]

export const exploreNav: Array<NavItem> = [
    { href: '/emotions', label: 'Emotion Finder' },
    { href: '/collections', label: 'Collections' },
    { href: '/timeline', label: 'Timeline' },
    { href: '/gallery', label: 'Artwork' },
    { href: '/search', label: 'Search' },
    { href: '/privacy', label: 'Privacy' }
]

export const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII']
